import * as R from 'ramda'

export default {
  validate (array) {
    const parseArrToInt = R.map((el) => parseInt(el))
    const isAsc = R.pipe(
      R.drop(1),
      (arr) =>
        arr.map((el, i) => R.none(R.isNil, [el, array[i]]) && el >= array[i]),
      (arr) => arr.every((is) => is)
    )
    const _arr = R.is(String, R.head(array)) ? parseArrToInt : R.clone(array)

    return isAsc(_arr)
  }
}
